import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGovernment: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGovernment"><Path fillRule="evenodd" clipRule="evenodd" d="M15 3H13V4.05664C16.832 4.48032 19.9366 7.30865 20.7744 11H22V13H21V19H22V21H2V19H3V13H2V11H3.22559C4.06345 7.30865 7.16804 4.48032 11 4.05664V0H15V3ZM5 13V19H8.33008V13H5ZM10.3301 13V19H13.6699V13H10.3301ZM15.6699 13V19H19V13H15.6699Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGovernment;
